import { useAtom } from 'jotai';
import { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { avalableROKInApartments, showAvailableState, showROKState } from '../states/planner';
import RadioButton from './RadioButton';

export const FilterButton = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [availableROK] = useAtom(avalableROKInApartments);

  const [rokFilter, setRokFilter] = useAtom(showROKState);
  const [showAvailable, setShowAvailable] = useAtom(showAvailableState);

  function toggleROK(rok: number) {
    const newRokFilter = [...rokFilter];
    newRokFilter[rok] = !newRokFilter[rok];
    toggleShowAvailable(true);
    setRokFilter(newRokFilter);
  }

  function toggleShowAvailable(set?: boolean) {
    setShowAvailable(set || !showAvailable);
  }

  if (availableROK.filter(item => item > 0).length < 2) return <></>;

  return (
    <li className="ml-6 h-6">
      <button
        className="font-style-one ml-auto font-bold"
        data-tooltip-id="filterBox"
        onClick={() => setShowFilter(!showFilter)}
      >
        Filtrera
      </button>
      <Tooltip
        id="filterBox"
        openOnClick
        clickable
        afterShow={() => setShowFilter(true)}
        afterHide={() => setShowFilter(false)}
        className="z-10 -ml-1 mt-2 bg-white"
        noArrow
        place="bottom-end"
        style={{
          backgroundColor: 'white',
          color: 'black',
          visibility: showFilter ? 'visible' : 'hidden',
        }}
      >
        <ul key="filter-list">
          {rokFilter.map((rok, index) => {
            const roomsAvailable = availableROK[index];

            if (!roomsAvailable) return '';

            return (
              <li key={`rok-${index}`} className="font-style-one mb-2 flex items-center font-bold">
                {index + 1} rok
                <RadioButton checked={rokFilter[index]} action={() => toggleROK(index)} />
              </li>
            );
          })}
        </ul>
      </Tooltip>
    </li>
  );
};
